import styled from 'styled-components';

const MarkerWrapper = styled.div`
  position: relative;
  cursor: pointer;
  width: 53px;
  height: 66px;
  transform: translate(-55%, -84%);
`;

const StyledSvg = styled.svg`
  position: absolute;
  z-index: 1;
  top: -5px;
  left: -39px;
  width: 94px;
  height: 81px;
  transform: rotate(180deg);
`;

const StyledPath = styled.path`
  fill: ${(props) => props.theme.color.cta};
  stroke: ${(props) => props.theme.color.white500};
  stroke-width: 2px;
`;

const MarkerText = styled.div`
  position: absolute;
  top: 19px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
  color: ${(props) => props.theme.color.white500};
  font-family: ${(props) => props.theme.font.bold};
  font-size: 15px;
  width: 100%;
  text-align: center;
`;

/**
 * @param {MarkerProps} props
 * @returns {React.ReactElement} The rendered component
 */
const Marker = ({ count, onClick, lat, lng }) => {
  return (
    <MarkerWrapper role="button" onClick={() => onClick(lat, lng)}>
      <StyledSvg viewBox="0 0 50 42">
        <StyledPath
          d="M15 6
             Q 15 6, 25 18
             A 12.8 12.8 0 1 1 5 18
             Q 15 6 15 6z"
        />
      </StyledSvg>
      <MarkerText>{count}</MarkerText>
    </MarkerWrapper>
  );
};

export default Marker;
